import { enUS as fallbackLocale, type Locale } from 'date-fns/locale';

export const supportedLanguages = [
  'cs-CZ',
  'da-DK',
  'de-DE',
  'en-US',
  'es-ES',
  'et-EE',
  'fi-FI',
  'fr-FR',
  'it-IT',
  'lv-LV',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'ru-RU',
  'sk-SK',
  'sl-SI',
  'sv-SE',
] as const;

type SupportedLanguage = typeof supportedLanguages[number];

const requireLocale: Record<string, () => Promise<Locale>> = {
  'cs-CZ': () => import('date-fns/locale/cs').then((module) => module.cs),
  'da-DK': () => import('date-fns/locale/da').then((module) => module.da),
  'de-DE': () => import('date-fns/locale/de').then((module) => module.de),
  'en-US': () => import('date-fns/locale/en-US').then((module) => module.enUS),
  'es-ES': () => import('date-fns/locale/es').then((module) => module.es),
  'et-EE': () => import('date-fns/locale/et').then((module) => module.et),
  'fi-FI': () => import('date-fns/locale/fi').then((module) => module.fi),
  'fr-FR': () => import('date-fns/locale/fr').then((module) => module.fr),
  'it-IT': () => import('date-fns/locale/it').then((module) => module.it),
  'lv-LV': () => import('date-fns/locale/lv').then((module) => module.lv),
  'nb-NO': () => import('date-fns/locale/nb').then((module) => module.nb),
  'nl-NL': () => import('date-fns/locale/nl').then((module) => module.nl),
  'pl-PL': () => import('date-fns/locale/pl').then((module) => module.pl),
  'ru-RU': () => import('date-fns/locale/ru').then((module) => module.ru),
  'sk-SK': () => import('date-fns/locale/sk').then((module) => module.sk),
  'sl-SI': () => import('date-fns/locale/sl').then((module) => module.sl),
  'sv-SE': () => import('date-fns/locale/sv').then((module) => module.sv),
};

export const getLocale = async (
  language?: string,
): Promise<Locale> => {
  if (language && supportedLanguages.includes(language)) {
    const locale = await requireLocale[language as SupportedLanguage]();
    return locale;
  }
  return fallbackLocale;
};

export { fallbackLocale };
export type { Locale };
